new Vue({
    el: '#availabilities',
    data: {
        message: 'Availabilities',
        floorplan_image: '',
        pdf_link: '#',
        show_vt_link: '0',
        vt_link: '#',
        selected_suite: '',
    },

    methods:
    {
        onClick: function (item, event) {

            event.preventDefault();

            var data = {
                action: 'my-custom-action',
                suite: item
            }


            var options = {
                emulateJSON: true
            }

            this.$http.post(themosis.ajaxurl, data, options).then(function(response) {
                console.log(response.data);
                data = response.data;
                this.message = data.suite_number;
                this.floorplan_image = data.floorplan_image;
                this.pdf_link = data.pdf;
                this.show_vt_link = data.show_vt_link;
                this.vt_link = data.vt_link;
                this.selected_suite = data.selected_suite;

                
                $('.avail-slide-item').removeClass('active');
                $('#' + data.ID).addClass('active');
                
            }, function (response) {
                //error call back;
            });
            //this.message = 'clicked ajax ' + item;
        }
    }

})